var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComboChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 6.75H16.125V15.75H13.875V6.75ZM10.875 9.75H13.125V15.75H10.875V9.75ZM7.875 8.25H10.125V15.75H7.875V8.25ZM4.875 12H7.125V15.75H4.875V12ZM1.875 10.5H4.125V15.75H1.875V10.5Z",
    fill: "#979CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.125C3.62132 7.125 4.125 6.62132 4.125 6C4.125 5.37868 3.62132 4.875 3 4.875C2.37868 4.875 1.875 5.37868 1.875 6C1.875 6.62132 2.37868 7.125 3 7.125Z",
    fill: "#979CA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.875C6.62132 7.875 7.125 7.37132 7.125 6.75C7.125 6.12868 6.62132 5.625 6 5.625C5.37868 5.625 4.875 6.12868 4.875 6.75C4.875 7.37132 5.37868 7.875 6 7.875Z",
    fill: "#979CA6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.25C9.62132 5.25 10.125 4.74632 10.125 4.125C10.125 3.50368 9.62132 3 9 3C8.37868 3 7.875 3.50368 7.875 4.125C7.875 4.74632 8.37868 5.25 9 5.25Z",
    fill: "#979CA6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12.6213 6 13.125 5.49632 13.125 4.875C13.125 4.25368 12.6213 3.75 12 3.75C11.3787 3.75 10.875 4.25368 10.875 4.875C10.875 5.49632 11.3787 6 12 6Z",
    fill: "#979CA6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5C15.6213 4.5 16.125 3.99632 16.125 3.375C16.125 2.75368 15.6213 2.25 15 2.25C14.3787 2.25 13.875 2.75368 13.875 3.375C13.875 3.99632 14.3787 4.5 15 4.5Z",
    fill: "#979CA6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6625 2.69922L11.925 4.08672L8.8125 3.29922L5.8125 5.92422L3.1875 5.28672L2.8125 6.71172L6.1875 7.57422L9.1875 4.94922L12.075 5.66172L15.3375 4.04922L14.6625 2.69922Z",
    fill: "#979CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboChart);
export default __webpack_public_path__ + "static/media/combo-chart.ec306be8b792d5352067095101c68948.svg";
export { ForwardRef as ReactComponent };